<template>
	<div>
		<div class="title-container">
			<div class="title">Create Account</div>
			<div class="buttons">
				<router-link :to="{ name: 'super-accounts-page', params: $route.params }" exact class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
			</div>
		</div>

		<form ref="form" method="post" @submit.prevent="onSubmit">
			<form-errors :errors="errors"></form-errors>

			<field-errors v-if="submitAttempted" :form="$v.form" field="company"></field-errors>
			<div class="input-container">
				<div class="input-title">Company</div>
				<div class="input-box"><input v-model="form.company" type="text"></div>
			</div>

			<field-errors v-if="submitAttempted" :form="$v.form" field="domain"></field-errors>
			<div class="input-container">
				<div class="input-title">Google Storage Domain</div>
				<div class="input-box"><input v-model="form.domain" type="text"></div>
			</div>

            <div class="title-container">
                <div class="title">Database Settings</div>
            </div>
			<div class="conjoin-input-containers">
				<field-errors v-if="submitAttempted" :form="$v.form" field="database"></field-errors>
				<div class="input-container">
					<div class="input-title">Database Name</div>
					<div class="input-box"><input v-model="form.database" type="text"></div>
				</div>

				<field-errors v-if="submitAttempted" :form="$v.form" field="database_friendly_name"></field-errors>
				<div class="input-container">
					<div class="input-title">Database Friendly Name</div>
					<div class="input-box"><input v-model="form.database_friendly_name" type="text"></div>
				</div>

				<field-errors v-if="submitAttempted" :form="$v.form" field="database_host"></field-errors>
				<div class="input-container">
					<div class="input-title">Database Host</div>
					<div class="input-box"><input v-model="form.database_host" type="text"></div>
				</div>

				<field-errors v-if="submitAttempted" :form="$v.form" field="database_port"></field-errors>
				<div class="input-container">
					<div class="input-title">Database Port</div>
					<div class="input-box"><input v-model="form.database_port" type="text" placeholder="Ex: 25060"></div>
				</div>

				<field-errors v-if="submitAttempted" :form="$v.form" field="database_username"></field-errors>
				<div class="input-container">
					<div class="input-title">Database Username</div>
					<div class="input-box"><input v-model="form.database_username" type="text"></div>
				</div>

				<field-errors v-if="submitAttempted" :form="$v.form" field="database_password"></field-errors>
				<div class="input-container">
					<div class="input-title">Database Password</div>
					<div class="input-box"><input v-model="form.database_password" type="text"></div>
				</div>
			</div>

            <div class="title-container">
                <div class="title">Analytics Settings</div>
                <div class="buttons">
                    <a href @click.prevent="form.analytics.push({})" class="button"><div class="hover-title">Add Another</div><span class="fa fa-plus"></span></a>
                </div>
            </div>

			<div v-for="(analytics, i) in form.analytics" :key="`analytics-${i}`" class="conjoin-input-containers">
                <div class="input-container">
                    <div class="input-title">Domain<a href @click.prevent="() => removeAnalytics(i)" tabindex="-1"><span class="fa fa-trash"></span></a></div>
                    <div class="input-box"><input type="text" v-model="form.analytics[i].domain"></div>
                </div>
                <field-errors v-if="submitAttempted" :form="$v.form" field="analytics"></field-errors>
                <div class="input-container">
                    <div class="input-title add-border-right">Property ID</div>
                    <div class="input-box"><input v-model="form.analytics[i].property_id" type="text"></div>
                </div>
				<div class="input-container">
					<div class="input-title">SE Ranking ID</div>
					<div class="input-box"><input type="text" v-model="form.analytics[i].se_ranking_id"></div>
				</div>
			</div>

            <div class="title-container">
                <div class="title">SEO Settings</div>
            </div>
			<div class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="has_seo" name="has_seo" v-model="form.has_seo">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="has_seo" class="input-checkbox-text">SEO Subscriber</label>
				</div>
			</div>

            <div class="title-container">
                <div class="title">Account Settings</div>
            </div>
			<field-errors v-if="submitAttempted" :form="$v.form" field="is_advanced_user"></field-errors>
			<div class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="is_advanced_user" name="is_advanced_user" v-model="form.is_advanced_user">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="is_advanced_user" class="input-checkbox-text">Allow HTML Access</label>
				</div>
			</div>

			<field-errors v-if="submitAttempted" :form="$v.form" field="is_active"></field-errors>
			<div class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="has_commerce" name="has_commerce" v-model="form.has_commerce">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="has_commerce" class="input-checkbox-text">Account Has E-Commerce</label>
				</div>
			</div>

			<field-errors v-if="submitAttempted" :form="$v.form" field="is_active"></field-errors>
			<div class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="is_active" name="is_active" v-model="form.is_active">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="is_active" class="input-checkbox-text">Account Is Active</label>
				</div>
			</div>

			<submit-button text="Save Account" icon="fa-save" :has-errors="hasErrors" :loading="formSaving"></submit-button>
		</form>
	</div>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import { required } from 'vuelidate/lib/validators';

export default {

	mixins: [FormMixin],

	name: 'AccountsCreatePage',

	data() {
		return {
			form: {
				database_port: 25060,
				is_active: true,
				analytics: [{}],
			},
		};
	},

	validations: {
		form: {
			company: { required },
			domain: { required },
			database: { required },
			database_host: { required },
			database_port: { required },
			database_friendly_name: { required },
			database_username: { required },
		},
	},

	methods: {

		removeAnalytics(i) {
			this.form.analytics.splice(i, 1);
			if (this.form.analytics.length === 0) {
				this.form.analytics.push({});
			}
		},

		async onSubmit() {
			this.submit(async () => {
				await this.$api.post(`/super/accounts/`, this.form);

				this.$store.dispatch('addToast', 'Account has been created & database migrated');
				this.$store.dispatch('getAccounts');
				this.$router.back();
			}, (e) => {
				this.$store.dispatch('errorToast', 'Unable to save account: ' + e.message);
			});
		},

	},

};

</script>
